import React, {useEffect} from 'react'
import Page from 'components/Page';
import {makeStyles} from "@material-ui/styles";
import PurchasingGroupStagesRouter from "./PurchasingGroupStagesRouter";
import PurchaserGroupInfoBar from "./components/PurchaserGroupInfoBar";
import {connect} from "react-redux";
import PurchasingGroupStage1Service from "../../../../services/PurchasingGroupStage1Service";
import PurchaserGroupStageBar from "./components/PurchaserGroupStageBar";
import Loading from "../../../../components/Loading";


const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2)
    }
}));

function PurchasingGroupStages(
    {
        match,
        location,
        purchaserGroupHeader
    }) {
    const classes = useStyles();

    const groupId = match.params.id;

    useEffect(() => {
        PurchasingGroupStage1Service.getHeader(groupId);
        return () => {
            PurchasingGroupStage1Service.clearResources(PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID)
        }
    }, [groupId])

    return (<Page>
        {!purchaserGroupHeader ? <div className={classes.content}><Loading /></div> : <>

            <PurchaserGroupInfoBar purchaserGroupHeader={purchaserGroupHeader}/>
            <PurchaserGroupStageBar purchaserGroupHeader={purchaserGroupHeader}/>
            <div className={classes.content}>
                <PurchasingGroupStagesRouter match={match}/>
            </div>
        </>}
    </Page>)
}

PurchasingGroupStages.propTypes = {}

export default connect((state) => ({
    purchaserGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID]
}), {})(PurchasingGroupStages);
	
